import '@babyfs/babyfs-console';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/modules/es6.typed.array-buffer';
import 'core-js/modules/es6.typed.int8-array';
import 'core-js/modules/es6.typed.uint8-array';
import 'core-js/modules/es6.typed.uint8-clamped-array';
import 'core-js/modules/es6.typed.int16-array';
import 'core-js/modules/es6.typed.uint16-array';
import 'core-js/modules/es6.typed.int32-array';
import 'core-js/modules/es6.typed.uint32-array';
import 'core-js/modules/es6.typed.float32-array';
import 'core-js/modules/es6.typed.float64-array';
import 'core-js/modules/es6.map';
import 'core-js/modules/es6.set';
import 'core-js/modules/es6.weak-map';
import 'core-js/modules/es6.weak-set';
import 'core-js/modules/es6.reflect.apply';
import 'core-js/modules/es6.reflect.construct';
import 'core-js/modules/es6.reflect.define-property';
import 'core-js/modules/es6.reflect.delete-property';
import 'core-js/modules/es6.reflect.get';
import 'core-js/modules/es6.reflect.get-own-property-descriptor';
import 'core-js/modules/es6.reflect.get-prototype-of';
import 'core-js/modules/es6.reflect.has';
import 'core-js/modules/es6.reflect.is-extensible';
import 'core-js/modules/es6.reflect.own-keys';
import 'core-js/modules/es6.reflect.prevent-extensions';
import 'core-js/modules/es6.reflect.set';
import 'core-js/modules/es6.reflect.set-prototype-of';
import 'core-js/modules/es6.promise';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es6.object.freeze';
import 'core-js/modules/es6.object.seal';
import 'core-js/modules/es6.object.prevent-extensions';
import 'core-js/modules/es6.object.is-frozen';
import 'core-js/modules/es6.object.is-sealed';
import 'core-js/modules/es6.object.is-extensible';
import 'core-js/modules/es6.object.get-own-property-descriptor';
import 'core-js/modules/es6.object.get-prototype-of';
import 'core-js/modules/es6.object.keys';
import 'core-js/modules/es6.object.get-own-property-names';
import 'core-js/modules/es6.object.assign';
import 'core-js/modules/es6.object.is';
import 'core-js/modules/es6.object.set-prototype-of';
import 'core-js/modules/es6.function.name';
import 'core-js/modules/es6.string.raw';
import 'core-js/modules/es6.string.from-code-point';
import 'core-js/modules/es6.string.code-point-at';
import 'core-js/modules/es6.string.repeat';
import 'core-js/modules/es6.string.starts-with';
import 'core-js/modules/es6.string.ends-with';
import 'core-js/modules/es6.string.includes';
import 'core-js/modules/es6.regexp.flags';
import 'core-js/modules/es6.regexp.match';
import 'core-js/modules/es6.regexp.replace';
import 'core-js/modules/es6.regexp.split';
import 'core-js/modules/es6.regexp.search';
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es6.array.of';
import 'core-js/modules/es6.array.copy-within';
import 'core-js/modules/es6.array.find';
import 'core-js/modules/es6.array.find-index';
import 'core-js/modules/es6.array.fill';
import 'core-js/modules/es6.array.iterator';
import 'core-js/modules/es6.number.is-finite';
import 'core-js/modules/es6.number.is-integer';
import 'core-js/modules/es6.number.is-safe-integer';
import 'core-js/modules/es6.number.is-nan';
import 'core-js/modules/es6.number.epsilon';
import 'core-js/modules/es6.number.min-safe-integer';
import 'core-js/modules/es6.number.max-safe-integer';
import 'core-js/modules/es6.math.acosh';
import 'core-js/modules/es6.math.asinh';
import 'core-js/modules/es6.math.atanh';
import 'core-js/modules/es6.math.cbrt';
import 'core-js/modules/es6.math.clz32';
import 'core-js/modules/es6.math.cosh';
import 'core-js/modules/es6.math.expm1';
import 'core-js/modules/es6.math.fround';
import 'core-js/modules/es6.math.hypot';
import 'core-js/modules/es6.math.imul';
import 'core-js/modules/es6.math.log1p';
import 'core-js/modules/es6.math.log10';
import 'core-js/modules/es6.math.log2';
import 'core-js/modules/es6.math.sign';
import 'core-js/modules/es6.math.sinh';
import 'core-js/modules/es6.math.tanh';
import 'core-js/modules/es6.math.trunc';
import 'core-js/modules/es7.array.includes';
import 'core-js/modules/es7.object.values';
import 'core-js/modules/es7.object.entries';
import 'core-js/modules/es7.object.get-own-property-descriptors';
import 'core-js/modules/es7.string.pad-start';
import 'core-js/modules/es7.string.pad-end';
import 'core-js/modules/web.timers';
import 'core-js/modules/web.immediate';
import 'core-js/modules/web.dom.iterable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import app from './app.vue';
import router from './router';
import '../../static/style/common.less';
import cookie from 'babyfs-cookie';
import log from 'babyfs-web-log';
import toast from 'babyfs-component-toast';
import 'babyfs-component-toast/dist/babyfs-toast.min.css';
Vue.use(toast);
Vue.use(log, 'wx_m_h5');

Vue.config.productionTip = false;

Vue.prototype.$cookie = cookie;

var getUrlParam = function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); // 构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); // 匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; // 返回参数值
};
var parseUrl = function parseUrl(_url) {
  //定义函数
  var pattern = /(\w+)=(\w+)/ig; //定义正则表达式
  var parames = {}; //定义数组
  _url.replace(pattern, function (a, b, c) {
    parames[b] = c;
  });
  return parames; //返回这个数组.
};
Vue.prototype.getUrlParam = getUrlParam;

require('./static/js/flexible');

require('adhoc-sdk-v');
window.adhoc('init', {
  appKey: 'ADHOC_99a022a8-025b-414d-996b-4b664f83216a',
  custom: { channel_id: parseUrl(location.href).channel_id // parseUrl获取页面url后面的参数
  } });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: {
    app: app
  },
  template: '<app/>'
});